import styled from 'styled-components';
import { Alert, Button } from 'antd';

export const SplitProductAlert = styled(Alert)`
  margin-bottom: ${({ theme }) => theme.spacing.space_3};
`;

export const ProductValueRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.space_3};
  margin-bottom: ${({ theme }) => theme.spacing.space_3};
`;

export const TariffRow = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.space_4};
`;

export const TariffRowLabel = styled.div`
  font-weight: bold;
  margin-bottom: ${({ theme }) => theme.spacing.space_1};
`;

export const TariffRowContent = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing.space_4};
  min-width: 50%;
  width: fit-content;
`;

export const DutyInfo = styled.div`
  display: flex;
  flex-direction: column;
  min-width: ${({ theme }) => theme.spacing.space_7};
`;

export const RemoveButton = styled(Button)``;
